import React from 'react';
import SparkSyncSuspendButton from 'src/components/HeadingWithDetails/Components/SparkSyncButton';
import useSparkSyncSuspendEnable from 'src/SharedCustomHooks/UseSparkSync/useSparkSyncSuspendEnable';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import './SparkSyncCell.scss';

interface SparkSyncCellProps {
  propertyId: string;
  isSpark: boolean;
}

const SparkSyncCell = ({ propertyId, isSpark }: SparkSyncCellProps) => {
  const {
    sparkSyncSuspended,
    isTogglingSuspend,
    isConfirmModalOpen,
    openSuspendConfirmModal,
    closeConfirmModal,
    confirmSuspendAction,
    confirmModalProps,
  } = useSparkSyncSuspendEnable(propertyId);

  if (!isSpark) {
    return (
      <span className="spark-sync-cell-disabled">
        Not enabled
      </span>
    );
  }

  return (
    <>
      <SparkSyncSuspendButton
        sparkSyncSuspended={sparkSyncSuspended}
        isTogglingSuspend={isTogglingSuspend}
        onToggleSuspend={openSuspendConfirmModal}
      />
      {isConfirmModalOpen && (
        <ConfirmationModal
          title={confirmModalProps.title}
          message={confirmModalProps.message}
          confirmLabel={confirmModalProps.confirmLabel}
          cancelLabel={confirmModalProps.cancelLabel}
          variant={confirmModalProps.variant}
          requireTypeToConfirm={confirmModalProps.requireTypeToConfirm}
          confirmationWord={confirmModalProps.confirmationWord}
          onConfirm={confirmSuspendAction}
          onCancel={closeConfirmModal}
          isSubmitting={isTogglingSuspend}
        />
      )}
    </>
  );
};

export default SparkSyncCell;